<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-chart-line" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Aging</div>
      </template>

      <v-btn
        id="btn-novo-aging"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Aging
      </v-btn>

      <v-text-field
        id="aging-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Aging" />
      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        no-data-text="Nenhum Aging disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-aging"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>

          <v-btn
            id="action-painel-gerencial-aging"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :disabled="item.status != 'SUCESSO'"
            @click="abrirPainelGerencial(item)"
          >
            <v-icon small>mdi-chart-box</v-icon>
          </v-btn>

          <v-btn
            id="action-edit-aging"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-aging"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.titulo)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-information-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="((dialogCreationLog = true), (dialogCreationLogData = { username: item.usuario, created: item.created }))"
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os registros de Aging</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Aging #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o Aging
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes do Aging"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          dense
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          disable-pagination
          class="elevation-1 style-table-dialog-detalhes"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.parametro === 'Status'" class="button">
                <general-status :status="row.item.valor" />
              </td>
              <td
                v-else-if="row.item.valor && typeof row.item.valor === 'object' && 'logs_tecnicos' in row.item.valor"
                class="button"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-btn-logs"
                      icon
                      color="black"
                      :loading="loadingLogsTecnicos"
                      v-bind="attrs"
                      @click="downloadLogsTecnicos(row.item.valor.id)"
                      v-on="on"
                    >
                      <v-icon size="18">mdi-file-download-outline</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="loadingLogsTecnicos">Baixando...</span>
                  <span v-else>Clique aqui para baixar os logs técnicos</span>
                </v-tooltip>
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>

    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import AgingService from '@/services/AgingService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['rechargeTable'],

    data: () => ({
      powerupService: AgingService,
      powerupEntityName: 'Aging',
      search: '',
      headers: [
        { text: '#', value: 'id' },
        { text: 'Título', value: 'titulo' },
        { text: 'Data Base', value: 'data_base' },
        { text: 'Data Projetada', value: 'data_projetada' },
        { text: 'Executado', value: 'data_processamento' },
        { text: 'Status', value: 'status' },
        { sortable: false, text: 'Ações', value: 'actions', class: 'pl-4' }
      ]
    }),

    methods: {
      formatTucsLabel(tucs) {
        if (tucs == null || tucs === '') {
          return '-';
        }

        if (Array.isArray(tucs)) {
          return tucs.join(', ');
        }

        return String(tucs);
      },

      abrirPainelGerencial(item) {
        this.$router.push(`/aging/painel-gerencial/${item.id}`);
      },

      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          { parametro: 'ID', valor: item.id },
          { parametro: 'Título', valor: item.titulo },
          { parametro: 'Data Base', valor: item.data_base || '-' },
          { parametro: 'Data Projetada', valor: item.data_projetada || '-' },
          { parametro: 'Tipo da Base', valor: item.tipo_base || '-' },
          { parametro: 'TUCs escolhidas', valor: this.formatTucsLabel(item.tucs_label) },
          { parametro: 'Status', valor: item.status },
          { parametro: 'Executado em', valor: item.data_processamento || '-' },
          { parametro: 'Criado por', valor: item.usuario || '-' },
          { parametro: 'Criado em', valor: this.formatDateHour(item.created) || '-' }
        ];

        if (this.userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)) {
          this.dialogDetalhesData.push(
            { parametro: ' ', valor: ' ' },
            { parametro: 'LOGS TÉCNICOS:', valor: { id: item.id, logs_tecnicos: true } }
          );
        }

        this.dialogDetalhes = true;
      }
    }
  };
</script>
